// extracted by mini-css-extract-plugin
module.exports = {"resultList":"Month_resultList__3N1fT"};